module.exports = __webpack_public_path__ + "img/tree.5322090f.jpg";